<template>
  <li
    class="nav-option flex items-center"
    :class="{ ['icon-disabled']: disabled }"
  >
    <button
      class="square-icon-button"
      :class="disabled ? 'button-disabled' : null"
      :aria-labelledby="'text-for-' + icon"
    >
      <span
        :class="useSymbol ? 'material-symbols-outlined' : 'material-icons'"
        aria-hidden="true"
        >{{ icon }}</span
      >
    </button>
    <span
      :id="'text-for-' + icon"
      class="nav-option__title ml-2"
      aria-hidden="true"
    >
      {{ title }}
    </span>
  </li>
</template>

<script setup lang="ts">
withDefaults(
  defineProps<{
    disabled?: boolean;
    icon: string;
    title: string;
    useSymbol?: boolean;
  }>(),
  {
    disabled: false,
    useSymbol: false,
  }
);
</script>

<style lang="scss" scoped>
@use "@/assets/styles/reader.scss" as *;

.nav-option {
  border: $spacingXS solid transparent;
  padding: 0 $spacingXL 0 $spacingM;
  cursor: pointer;
  @include hover();
  .square-icon-button {
    border-color: transparent;
    background-color: transparent;
    @include hover();
    &:hover {
      background-color: transparent;
      border: transparent;
    }
  }
}
</style>
